import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
} from 'react-router-dom';

import {
  Button,
  Typography,
  Paper,
  Grid,
  Chip
} from '@material-ui/core';
import ChevronRight from '@material-ui/icons/ChevronRight';

import Masonry from 'react-masonry-component';

import Navbar from '../../common/containers/Navbar';
import LoginModal from '../../auth/components/LoginModal';
import EventListItem from '../components/EventListItem';
import NewsListItem from '../components/NewsListItem';
import Footer from '../../common/components/Footer';
import * as mainActions from '../actions';
import {
  getHomeCover, getHomeCaption, getKakaImage, getKakaTagline,
} from '../../util';

import homeImg from '../../assets/img/homeImg.png';
import inspBack from '../../assets/backs/bloom.png';

import classes from "../../css/getCSS";
import * as constants from "../../config/constants";
import Axios from "axios";
import axios from "../../config/axios";
import { getAuthHeaders } from "../../auth/actions";
import * as routes from "../../config/routes";

class Home extends Component {
  state = {
    loginModalOpen: false,
    solidNavbar: false,
    isModalSignup: false,
  }

  componentWillMount() {
    console.log('------componentWillMount---home');
    const userData=JSON.parse(localStorage.getItem('user'))
    let userID=userData? userData.id: null
    Axios.get('https://ipapi.co/json/')
      .then((res) => {
        const data = res.data
        const ip = res.data.ip
        axios.get(`/disclaimers/complete-disclaimers?ip=${ip}&id=${userID}`)
          .then((response) => {
            if(response.data.disclaimer_accept){
              const token = localStorage.getItem('token')
              if (token && response.data.user_accept===false){
                const apiData = {
                  "ip": data.ip,
                  "city": data.city,
                  "country": data.country_name,
                  "region": data.region,
                  "latitude": data.latitude,
                  "longitude":data.longitude
                }
                axios.post('/disclaimers/complete-disclaimers', apiData, getAuthHeaders(token))
              }
            }
            else{
              this.props.history.push(routes.DISCLAIMER_MENU)
            }
          })
      })
  }git

  componentDidMount() {
    this.props.getEvents(this.props.site.id);
    this.props.getNews(this.props.site.id);
    this.navbar = <Navbar homeNavbar />;
    window.addEventListener('scroll', this.handleScroll);
    document.title = this.props.site.name;
  }

  componentWillUnmount() {
    window.addEventListener('scroll', this.handleScroll);
    this.props.onUnmount();
  }

  handleScroll = () => {
    const lastScrollY = window.scrollY;
    if (lastScrollY > 200) {
      this.setState({ solidNavbar: true });
    } else {
      this.setState({ solidNavbar: false });
    }
  }

  handleClickOpen = (flag) => {
    this.setState({
      loginModalOpen: true,
      isModalSignup: flag,
    });
  }

  handleClose = () => {
    this.setState({
      loginModalOpen: false,
    });
  }

  gotToLogin = () => {
    this.props.history.push('/login');
  }

  redirectToZone =(URL)=> {
    window.open('https://'+URL[0], '_blank');
  };

  render() {
    const homeBack = getHomeCover();
    const kakaImage = getKakaImage();
    const kakaTagline = getKakaTagline();

    const wrapperStyles = {
      backgroundImage: `url(${homeBack})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      minHeight: '200px',
    };

    const inspStyle = {
      backgroundImage: `url(${inspBack})`,
      padding: '40px 40px',
    };

    let events = (
      <div className={classes.card}>
        Loading events
      </div>
    );
    if (this.props.eventList && this.props.eventList.length > 0) {
      events = this.props.eventList.slice(0, 4).map((event) => {
        return (
          <div className={classes.homeMasonryItem} key={event.id}>
            <EventListItem
              showCaption
              homeItem
              {...event}
            />
          </div>
        );
      });
    }

    let newsList = (
      <div className={classes.card}>
        Loading news
      </div>
    );
    if (this.props.newsList && this.props.newsList.length > 0) {
      newsList = this.props.newsList.slice(0, 2).map((item) => {
        return (
          <div className={classes.homeMasonryItem} key={item.id}>
            <NewsListItem
              showCaption
              homeItem
              {...item}
            />
          </div>
        );
      });
    }

    const masonryOptions = {
      transitionDuration: 0,
    };

    const homeCoverCaption = getHomeCaption();
    if (this.props.eventList.length > 0) {
      events = (
        <Masonry options={masonryOptions}>
          {events}
        </Masonry>
      );
    } else {
      events = (
        <div className={classes.card}>
          No Events Live!
        </div>
      );
    }

    if (this.props.newsList.length > 0) {
      newsList = (
        <Masonry options={masonryOptions}>
          {newsList}
        </Masonry>
      );
    } else {
      newsList = (
        <div className={classes.card}>
          No News Found!
        </div>
      );
    }

    return (
      <React.Fragment>
        <div style={wrapperStyles} className='bannermain'>
          <Navbar homeNavbar solidNavbar={this.state.solidNavbar} />
          <div className={classes.container}>
            <div className={classes.homeCoverWrapper}>
              {homeCoverCaption}
              <br />
              { window.location.host !== constants.MAIN_SITE_HOST && <Button variant="contained" elevation={0} className={classes.captionButton} onClick={() => this.handleClickOpen(true)}>
                New Registration
                <ChevronRight />
              </Button>
              }
              <Button style={{ marginLeft: '10px' }} variant="contained" elevation={0} className={classes.captionButton} onClick={() => this.handleClickOpen()}>
                Login
                <ChevronRight />
              </Button>
            </div>

          </div>
        </div>
        <div className={classes.container}>
          <Paper className={[classes.card, classes.homeContentCard, classes.noPadding].join(" ")}>
            {window.location.host === constants.MAIN_SITE_HOST ?
              <div align="left" className={classes.homeSectionWrapper}>
                <Typography variant="headline">Our Zonal Websites</Typography>
                <span className={classes.titleUnderline} />
                <div style={{ marginBottom: "10px", fontSize: "17px" }}><span>Please register your profile in your zone website</span><br />
                  <span>આપની પ્રોફાઈલ નીચે આપેલ વેબસાઇટ(આપના એરિયા મુજબ) મા રજિસ્ટર કરો</span></div>
                <div className={classes.card}>
                  <h2 style={{ marginTop: "0px", fontWeight: "600" }}>Indian</h2>
                  <Grid container spacing={12} className={classes.columnGrid}>
                    {
                      constants.INDIAN_SITES.map((val, index) =>
                        <Chip className={classes.siteName}
                              variant="contained" label={<b>{val[1].toString().replace("Lagna Setu ", "")}</b>}
                              onClick={() => this.redirectToZone(val)} />
                      )
                    }
                  </Grid>
                  <hr style={{ borderColor: "#c0202c", borderWidth: "1px", borderStyle: "dashed" }} />
                  <h2 style={{ fontWeight: "600" }}>International</h2>
                  <Grid container spacing={12} className={classes.columnGrid}>
                    {
                      constants.INTERNATIONAL_SITES.map((val, index) =>
                        <Chip className={classes.siteName}
                              variant="contained" label={<b>{val[1].toString().replace("Lagna Setu ", "")}</b>}
                              onClick={() => this.redirectToZone(val)} />
                      )
                    }
                  </Grid>
                </div>
              </div>
              :
              constants.SITE_CITY.map((val) =>
                window.location.host === val[0] &&
                <div align="left" className={classes.homeSectionWrapper}>
                  <Typography variant="headline">{val[2]} Covered</Typography>
                  <span className={classes.titleUnderline} />
                  <div className={classes.card}>
                    {val[1]}
                  </div>
                </div>
              )
            }
            <div align="left" className={classes.homeSectionWrapper}>
              <Typography variant="headline">Events</Typography>
              <span className={classes.titleUnderline} />
              {events}
            </div>

            <div align="center" className={classes.homeSectionWrapper} style={inspStyle}>
              <Typography variant="headline" style={{ color: '#666' }}>Our Inspiration</Typography>
              <span className={classes.titleUnderline} style={{ color: '#666' }} />
              <Grid container style={{ display: 'flex', justifyContent: 'center' }}>
                <Grid item md={8} sm={10}>
                  <Grid container spacing={24}>
                    <Grid item md={2} sm={2} style={{margin:'auto'}}>
                      <img src={kakaImage} alt="inspiration" style={{ width: '95%', border: 'thin solid #666' }} />
                    </Grid>
                    <Grid item md={10} sm={10} align="left">
                      <Typography className={classes.homeContent} style={{ color: '#424242' }}>
                        {kakaTagline}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </div>

            <div align="left" className={classes.homeSectionWrapper}>
              <Typography variant="headline">News</Typography>
              <span className={classes.titleUnderline} />
              {newsList}
            </div>

            <div align="center" className={classes.homeSectionWrapper}>
              <img src={homeImg} alt="home" className={classes.homeImg} />
            </div>

          </Paper>
          <br /><br />

        </div>
        <Footer />
        <LoginModal
          loginModalOpen={this.state.loginModalOpen}
          handleClose={this.handleClose}
          isSignup={this.state.isModalSignup}
        />
      </React.Fragment>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    site: state.common.site,
    eventList: state.main.eventList,
    newsList: state.main.newsList,
    eventsLoaded: state.main.eventsLoaded,
    newsLoaded: state.main.newsLoaded,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUnmount: () => dispatch(mainActions.deepUnmount()),
    getEvents: (siteID, url) => dispatch(mainActions.getEvents(siteID, url)),
    getNews: (siteID, url) => dispatch(mainActions.getNews(siteID, url)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));



// WEBPACK FOOTER //
// ./src/main/containers/Home.js